import { Paginated } from "@feathersjs/feathers/lib";
import { authStore } from "app";
import client from "feathers";
import { Package, Program, User } from "models";
import { DataType, IProgramUser, Services } from "types";


export namespace SwedSec {
  
  export class Report {
    private year: number;

    constructor(private akuPackage: Package) {
      this.year = this.akuPackage.year;
      if(!this.year) throw new Error("Failed to find AKU year");
    }

    private loadParticipants = async(): Promise<User[]> => {
      const users: User[] = await User.getParticipants(
        DataType.Package, 
        this.akuPackage, 
        authStore.getCurUser.company.id
      );
      return users;
    }

    private loadPrograms = async(): Promise<Record<number, Program>> => {
      const programs = await Program.get(undefined, true, this.akuPackage) as Program[];
      if(programs.some(p => !p.aku_type)) throw new Error("Invalid program in this package.")
      return programs.reduce((res, val) => {
        res[val.id] = val;
        return res;
      }, {} as Record<number, Program>);
    }

    private loadFinishedParticipantMap = async (programs: Record<number, Program>, participants: User[]): Promise<Record<string, AKUType[]>> => {
      const programIds: number[] = Object.values(programs).map(p => p.id);
      
      // @TODO this ignores pagination right now. Current page limit is 1000
      const programUsers: Paginated<IProgramUser> = await client.service(Services.ProgramUser).find({
        query: {
          program_id: {$in: programIds}
        },
      });
      if(programUsers.total >= 1000) {
        console.error("Page limit reached!");
      }
      
      console.log({programUsers});

      return participants.reduce<Record<string, AKUType[]>>((res, val) => {
        console.log({val, data: programUsers.data});
        const hasAKUFinished = programUsers.data
          .filter(pu => {
            console.log('filter',  Number(pu.user_id), Number(val.id), Number(pu.user_id) === Number(val.id), pu.progress , Number(pu.progress) == 100)
            return Number(pu.user_id) === Number(val.id) && pu.progress && Number(pu.progress) == 100;
          }).length > 0;
          // .map(pu => {
          //   console.log('map progress', Number(pu.progress))
          //   return Number(pu.progress);
          // })
          // .filter(prog => {
          //   console.log({prog})
          //   return  prog < 100;
          // }).length < 1;
        console.log({hasAKUFinished, res})

        if(!hasAKUFinished) return res;

        const userProgramIds = programUsers.data
          .filter(pu => Number(pu.user_id) === Number(val.id))
          .map(pu => pu.program_id);

        res[val.personal_number] = userProgramIds
          .map(pId => programs[pId])
          .map(p => p.aku_type);
        return res;
      }, {} as Record<string, AKUType[]>);
    }

    public generateAKUUsers = async (ids?: string[]): Promise<AKUUser[]> => {
      const participants           = await this.loadParticipants();
      const programs               = await this.loadPrograms();
      const finishedParticipantMap = await this.loadFinishedParticipantMap(programs, participants);
      console.log({ids});
      console.log({participants});
      console.log({finishedParticipantMap});
      console.log({programs});
      return participants
        .filter(u => ids?.includes(u.personal_number))
        .filter(u => finishedParticipantMap[u.personal_number])
        .map(u => {
          console.log(u.personal_number)
          return {
            extend: finishedParticipantMap[u.personal_number],
            pnr:    this.formatPersonalNumber(u.personal_number),
            year:   this.year
        }
        });
    }
  
    public report = async (ids?: string[]): Promise<number|string> => {
      const akuUsers: AKUUser[] = await this.generateAKUUsers(ids);
      console.log('users sent to swedsec', {akuUsers})
      const response: {success_users: [], errors: any} = await client.service(Services.Swedsec).report(akuUsers);
      console.log(response);
      if( response.errors && Object.values(response.errors).length) {
        return Object.values(response.errors)[0] as string;
      } else {
        return response.success_users.length;
      }
    }

    private formatPersonalNumber(personalNumber: string): string {
      // Ensure the personal number is a string
      const str = String(personalNumber);
    
      // Check if the length is correct
      if (str.length !== 12) {
        throw new Error("Personal number must be 12 characters long.");
      }
    
      // Remove the first two characters if they are "20" or "19"
      let formattedStr = str;
      if (str.startsWith("20") || str.startsWith("19")) {
        formattedStr = str.slice(2);
      }
    
      // Insert the dash before the last four characters
      return formattedStr.slice(0, 6) + '-' + formattedStr.slice(6);
    }
  }

  export const testServerURL       = "https://integtest.cloud.swedsec.com";
  export const productionServerURL = "@TODO";

  export const apiReportEndpoint = "/api/v3/aku";
  export const apiTokenEndpoint = "/api/v3/oauth/token";

  export type AKUUser = {
    pnr:    string,
    extend: AKUType[],
    year:   number
  }

  export enum AKUType {
    Mortgages    = "Bolån",
    InfoProvider = "Informationsgivare",
    Management   = "Ledning och kontroll",
    Advisors     = "Rådgivare",
    Specialists  = "Specialister",
  }
}